import callApi from "../../api/axios";

export const getPartnersApproval = ({ limit, offset, status }) => {
  return callApi({
    method: "GET",
    url: `partners/registration?limit=${limit}&offset=${offset}&status=${status}`,
  });
};

export const acceptPartner = (id) => {
  return callApi({
    method: "POST",
    url: `partners/accept`,
    data: { partnerId: id },
  });
};

export const rejectPartner = ({ id, note }) => {
  return callApi({
    method: "POST",
    url: `partners/reject`,
    data: { partnerId: id, note },
  });
};

export const removePartner = (id) => {
  return callApi({
    method: "DELETE",
    url: `partners/${id}`,
  });
};
